import React from 'react';
import { Divider } from 'semantic-ui-react'

const VerCla1 = ({autorizacUA, styles, handleClickRegr, handleClickUpd, handleClickDel}) => {
  const a25010105 = autorizacUA.findIndex( autorizac => autorizac === "25010105" );
  const a25010110 = autorizacUA.findIndex( autorizac => autorizac === "25010110" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a25010105!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit violet icon"></i>
        Modificar
      </button>
      }
      {a25010110!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
        <i className="large trash alternate violet icon"></i>
        Eliminar
      </button>
      }
      <Divider inverted />
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default VerCla1
